/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper';

export const EVENT_CREATE = 'create';
export const EVENT_UPDATE = 'update';
export const EVENT_DELETE = 'delete';
export const EVENT_CREATE_OR_UPDATE = 'create-or-update';

export default declareEntity({
    name: "Events",
    graphQL: "Event",
    entity: 'events',
    storageType: 'silo',
    description: "Events of changes",
    userEditable: false,
	defaultOrder: [['createdAt', 'desc']],
    fields: (types) => { return {
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (channel) => {
                return channel['organisation_id'];
            },
            required: true
        },
        channel: {
            name: "Channel ID",
            type: "relation",
            to: () => types['channels'],
            defaultValue: (channel) => {
                return channel['id'];
            },
            required: true
        },
        channelDef: {
            name: "ChannelDef ID",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (channel) => {
                return channel['channelDef_id'];
            },
            required: true
        },
        sourceDef: {
            name: "SourceDef ID",
            type: "relation",
            to: () => types['sourceDefs'],
            required: true,
            relativeTo: ['channelDef'],
        },
        id: {
            name: "Event ID",
            type: "id",
            primaryKey: true,
            required: true
        },
        key: {
            name: "Key",
            type: "string",
            required: true,
        },
        row: {
            name: "Row",
            type: "object",
            defaultValue: {},
        },
        hasError: {
            name: "Has Error",
            type: "boolean",
            defaultValue: false,
        },
        hasPermanentError: {
            name: "Has Permanent Error",
            type: "boolean",
            defaultValue: false,
        },
        eventType: {
            name: "Event type",
            type: "enum",
            defaultValue: EVENT_CREATE,
            values: {
                [EVENT_CREATE]: {
                    name: "Create row"
                },
                [EVENT_CREATE_OR_UPDATE]: {
                    name: "Create or update if already exists"
                },
                [EVENT_UPDATE]: {
                    name: "Update row"
                },
                [EVENT_DELETE]: {
                    name: "Delete row"
                },
            }
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; }
});
